import { ChipProps, useTheme } from "@mui/material";
import { MprcChip } from "components/MprcChip";
import * as React from "react";

interface IProps {
    labelUppercase?: boolean;
    maxWidth?: string;
}

type Props = IProps & Omit<ChipProps, "color" | "onDelete" | "maxWidth" | "icon" | "avatar">;

export const MprcChipSuggestion: React.FC<Props> = (props) => {
    const { maxWidth = "270px", labelUppercase = false, size = "small", ...rest } = props;

    const theme = useTheme();

    return (
        <MprcChip
            {...rest}
            size={size}
            maxWidth={maxWidth}
            sx={
                {
                    ...props.sx,
                    margin: theme.spacing(.5),
                    backgroundColor: theme.palette.common.white,
                    color: theme.palette.muted.dark,
                    borderColor: theme.palette.muted.main,
                    borderStyle: "solid",
                    borderWidth: "1px",
                    textTransform: labelUppercase ? "uppercase" : undefined,
                    "&:hover": {
                        color: "white",
                        backgroundColor: theme.palette.highlight.dark
                    },
                    "& .MuiChip-label": {
                        padding: "0 16px",
                    },
                }
            }
        />
    );
};
